export const ESIM_CARD_TEST_ID = {
    SECTION: 'esim-info-card-section',
    TRIGGER: 'esim-info-card-trigger',
    MODAL: 'esim-info-card-modal',
    MODAL_CLOSE: 'esim-info-card-modal-close',
    MODAL_IMAGE: 'esim-info-card-modal-image',
};
